export default "__VITE_ASSET__Bkm1AJH2__"